/* eslint-disable react/no-deprecated */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from '../../actions/index'
import { styles } from './LoyaltyProgram.styles'
import { mainColor, UNIT, VERSION_MENU } from '../../constants'
import { Divider, Grid, List, ListItem, ListItemIcon, ListItemText, ListSubheader } from '@material-ui/core'
import _ from 'lodash'
import InputAdornment from '@material-ui/core/InputAdornment'
import Input from '../Input'
import UpdateIcon from '@material-ui/icons/Create'
import Modal from '../Modal'
import Checkbox from '../Checkbox'
import Paper from '../Paper'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined'
import StarsIcon from '@material-ui/icons/Stars'
import { hasExternalIntegration } from '../../utils/externalIntegration'
import Spinner from '../Spinner'
import {
  addParticipatingShops,
  addProducts,
  addVersion,
  getCommonProducts,
  getFilteredAndSortedProducts,
  handleChangeCheckbox,
  handleCheckboxChange,
  handlePointClick,
  updatePoint
} from './LoyaltyProgram.services'
import IconButton from '../IconButton'
import AddIcon from '@material-ui/icons/Add'

function LoyaltyProgram({ classes, shops, setStateObj, stateObj, openErrorModal, showModal }) {
  useEffect(() => {
    const { shops: shopIds } = stateObj.newVersion;
    const commonProducts = getCommonProducts(shopIds, stateObj.menus);
    setStateObj({ commonProducts })
  }, [stateObj.menus, stateObj.newVersion]);
  const renderVersionMenu = () => (
    < div >
      <List>
        {_.map(Object.values(VERSION_MENU), (config, index) => (
          <div key={config.text} className={index === 2 && (!stateObj.version.shops || _.size(stateObj.version?.shops) === 0) && classes.disabled}>
            <ListItem className={classes.gutters}>
              <ListItemIcon className={classes.icon}>{config.icon}</ListItemIcon>
              <ListItemText
                className={classes.versionPart}
                style={{ color: mainColor.colorBlack }}
                primary={<p className={classes.version}>{config.text}</p>}
                secondary={<p className={classes.textStyle}>{config.description}</p>}
              />
              <IconButton
                className={classes.updateIcon}
                onClick={() => {
                  if (index === 0) {
                    setStateObj({ isOpenConfiguration: true, createVersion: false });
                  } else if (index === 1) {

                    setStateObj({ isOpenShops: true, hasShops: stateObj.version?.shops?.length > 0 && stateObj.version?.program });
                  } else {
                    setStateObj({ isOpenProducts: true });

                  }
                }}
              >
                <UpdateIcon />
              </IconButton>


            </ListItem>
            {index < Object.values(VERSION_MENU).length - 1 && <Divider component='li' />}
          </div>
        ))}
      </List>
    </div >
  );

  const renderConfigurationForm = () => {
    const { versionName, rules, defaultVersion } = stateObj.version;
    return (
      <>
        <b>Nom de la version</b>
        <Input
          margin='dense'
          id='name'
          classes={{ label: classes.label }}
          placeholder='Nom de la version'
          value={versionName}
          onChange={e => (setStateObj({ version: { ...stateObj.version, versionName: e.target.value } }))}
          autoFocus
          fullWidth
        />
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={9}>
            <b>Panier minimal</b>
          </Grid>
          <Grid item xs={3}>
            <Input
              margin='dense'
              id='basket'
              type='number'
              classes={{ label: classes.label }}
              placeholder='20 '
              value={rules?.minBasket}
              onChange={e => (setStateObj({ version: { ...stateObj.version, rules: { minBasket: e.target.value } } }))}
              autoFocus
              InputProps={{
                endAdornment: <InputAdornment position='end'>€</InputAdornment>
              }}
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid className={classes.top} container spacing={2} alignItems="center">
          <Grid item xs={10}>
            <b>Fidélité par défaut</b>
            <p className={classes.default}>Visible pour les clients qui n'ont pas encore sélectionné de restaurant.</p>
          </Grid>
          <Grid item >
            <Checkbox
              value={defaultVersion}
              name='default'
              onClick={() => (setStateObj({ version: { ...stateObj.version, defaultVersion: !defaultVersion } }))}
            />
          </Grid>
        </Grid>
      </>
    )

  }


  const renderParticipatingRestaurants = () => {
    const { shops: partipatingShops = [] } = stateObj.version;
    const shopIds = []

    _.map(_.pickBy(stateObj.versions, elm => elm.key !== stateObj.version.key), version => {
      _.map(version.shops, shop => {

        if (shopIds.indexOf(shop) === -1) { shopIds.push(shop) }
      })
    })
    return (
      <Paper style={{ height: '374px', overflow: 'auto' }} className={classes.paper}>
        {_.map(shops, (shop, index) => {
          const { version } = shop?.configuration?.menu || {};
          const keys = Object.keys(shops).filter(shop => !shopIds.includes(shop));
          const isLastItem = keys[keys.length - 1] === index;
          if (!shopIds.includes(index))
            return (
              <React.Fragment key={shop.name} >
                <ListItem className={`${classes.itemStyle} py-1`}>
                  <ListItemIcon>
                    <Checkbox
                      value={partipatingShops && partipatingShops.includes(index)}
                      inputProps={{ 'aria-labelledby': shop.name }}
                      text={
                        <div className={classes.flexContainer}>
                          <p className={`${classes.titleStyle} mr-2`}>{shop.name}</p>
                        </div>
                      }
                      className='pt-0'
                      onClick={() => handleChangeCheckbox(stateObj, setStateObj, index)}
                    />
                  </ListItemIcon>
                  <ListItemText
                    style={{ color: mainColor.colorBlack }}
                    secondary={
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        {hasExternalIntegration(index) && <span className={classes.textStyle}>Intégration: {hasExternalIntegration(index)}</span>}
                        {version && <span className={classes.textStyle}>{`Version de menu ${version}`}</span>}
                      </div>
                    }
                  />
                </ListItem>
                {!isLastItem && <Divider />}
              </React.Fragment>
            )

        })}
      </Paper>
    )
  };

  const offeredProducts = () => {
    const { program = {} } = stateObj?.newVersion;
    const filteredProducts = getFilteredAndSortedProducts(stateObj);
    return (
      <Paper className={classes.paper}>
        <React.Fragment>
          <ListItem>
            <ListItemText
              style={{ color: mainColor.colorBlack }}
              secondary='Définir un palier de points :'
            />
            <ListItemText
              className={classes.palier}
              secondary={
                <Input
                  margin='dense'
                  id='point'
                  type='number'
                  value={stateObj.newPoint}
                  placeholder='50'
                  onChange={e => setStateObj({ newPoint: e.target.value ? parseInt(e.target.value) : null })}
                  InputProps={{
                    endAdornment: <InputAdornment position='end'>Points</InputAdornment>
                  }}

                  variant='outlined'
                />
              }
            />
            <ListItemIcon className='ml-2 pt-0'>
              <IconButton disabled={!stateObj.newPoint} style={{ color: stateObj.newPoint && mainColor.secondaryColor }} onClick={() => updatePoint(stateObj.newPoint, false, setStateObj, stateObj, openErrorModal)}>
                <AddIcon />
              </IconButton>
            </ListItemIcon>
          </ListItem>
          {_.size(program) > 0 && <Divider />}

        </React.Fragment>
        {_.size(program) > 0 &&
          <div className='p-2'>
            <div className={classes.list}>
              {_.map(_.values(program), (prg, index) => (
                <React.Fragment key={prg?.points} >
                  <ListItem
                    button
                    onClick={() => handlePointClick(
                      prg?.points,
                      setStateObj,
                      stateObj
                    )}
                    className={`py-0 ${index === 0
                      ? classes.pointBorderTop
                      : index === _.size(program) - 1 &&
                        prg?.points !== stateObj.openPoint
                        ? classes.pointBorderBottom
                        : ''
                      }`}
                    style={{
                      borderRadius: prg?.points !== stateObj.openPoint &&
                        _.size(program) === 1
                        ? UNIT
                        : undefined
                    }}
                  >
                    <ListItemIcon>
                      <StarsIcon style={{ color: '#e2e215' }} />
                    </ListItemIcon>
                    <ListItemText
                      style={{ color: mainColor.colorBlack }}
                      primary={`${prg?.points} Points`}
                    />
                    <ListItemIcon className={classes.leftArrow}>
                      <IconButton onClick={(e) => { updatePoint(prg?.points, true, setStateObj, stateObj, openErrorModal); e.stopPropagation() }}>
                        <DeleteOutlinedIcon />
                      </IconButton>

                    </ListItemIcon>
                  </ListItem>
                  {(index !== _.size(program) - 1 || prg?.points === stateObj.openPoint) && <Divider />}

                  {stateObj.openPoint === prg?.points && (
                    stateObj.isLoadingMenu ? <Spinner style={{ margin: '56px 171px 56px 182px' }} /> : filteredProducts.length > 0 ? (
                      <div className={`${classes.container} pb-2 pl-3`}>
                        {filteredProducts.map(section => (
                          <div key={section.key}>
                            <ListSubheader className={classes.sectionHeader}>
                              {section.name.toUpperCase()}
                            </ListSubheader>
                            {_.map(section.products, product => (
                              <ListItem key={product.key}>
                                <Checkbox
                                  name={product.key}
                                  value={product.selected}
                                  text={product.name}
                                  onClick={() =>
                                    handleCheckboxChange(product.key, stateObj, setStateObj)
                                  }
                                />
                              </ListItem>
                            ))}
                          </div>
                        ))}
                      </div>
                    ) : <p className='text-center p-3'>Aucun produit n'est disponible, merci de vérifier qu'il existe bien des produits communs aux restaurants sélectionnés dans cette version du programme de fidélité.</p>
                  )}
                  {index !== _.size(program) - 1 && prg.points === stateObj.openPoint && <Divider />}
                </React.Fragment>
              ))}
            </div>

          </div>
        }
      </Paper>
    );
  };






  const renderModal = (title, isOpen, onClick) => (

    <Modal
      color='secondary'
      btnTxt='Enregistrer'
      title={title}
      loading={stateObj.isLoading}
      header
      fixed
      showCancelBtn
      onClick={onClick}
      isOpen={isOpen}
      handleClose={() => setStateObj({ isOpenConfiguration: false, isOpenShops: false, isOpenProducts: false, openPoint: null, updateVersions: true, newPoint: null, version: { ...stateObj.version, program: {} } })
      }
    >
      {stateObj.isOpenConfiguration ? renderConfigurationForm() : stateObj.isOpenShops ? renderParticipatingRestaurants() : offeredProducts()}
    </Modal>
  );

  return (
    <>
      <div>
        {stateObj.versionConfig !== '' && renderVersionMenu()}
        {renderModal(`${stateObj.createVersion ? 'Ajouter une nouvelle' : 'Modifier la'} version du programme de fidélité`, stateObj.isOpenConfiguration, () => addVersion(stateObj, setStateObj, openErrorModal))}
        {renderModal('Choix des restaurants participants', stateObj.isOpenShops, () => addParticipatingShops(stateObj, setStateObj, openErrorModal, showModal, shops, false))}
        {renderModal('Définissez vos paliers de points et vos produits offerts', stateObj.isOpenProducts, () => addProducts(stateObj, setStateObj, openErrorModal))}
      </div>
    </>
  );
}

function mapStateToProps({ firebaseRealTime }) {
  const { shops = {} } = firebaseRealTime;
  return { shops };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(LoyaltyProgram)));